import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, map, of, switchMap } from 'rxjs';

import { FormService } from '../../components/form/services/form.service';
import { ConversationConfigService } from '../../services/conversation/conversation-config/conversation-config.service';
import { AdminRolesService } from '../../services/user/admin-roles/admin-roles.service';
import { RolesService } from '../../services/user/roles/roles.service';

@UntilDestroy()
@Component({
  selector: 'app-org-settings',
  templateUrl: './org-settings.component.html',
  styleUrls: ['./org-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgSettingsComponent implements OnInit {
  private readonly adminRolesService = inject(AdminRolesService);

  private readonly rolesService = inject(RolesService);

  private readonly formService = inject(FormService);

  private readonly conversationConfigService = inject(ConversationConfigService);

  public conversationConfigExists: boolean = false;

  private readonly isPwpAdmin$ = this.adminRolesService
    .getAdminRoles()
    .pipe(map((adminRoles) => adminRoles.isPwpAdmin()));

  private readonly isOrgAdmin$ = this.rolesService.getRoles().pipe(map((roles) => roles.isOrgAdmin()));

  public readonly isFormsTabVisible$ = combineLatest([this.isPwpAdmin$, this.isOrgAdmin$]).pipe(
    switchMap(([isPwpAdmin, isOrgAdmin]) => {
      if (isPwpAdmin) {
        return of(true);
      }

      if (!isOrgAdmin) {
        return of(false);
      }

      return this.formService.getUniqueDoc({ query: [] }).pipe(map((form) => Boolean(form)));
    }),
  );

  public ngOnInit() {
    this.conversationConfigService
      .getUniqueDoc({ query: [] })
      .pipe(
        map((config) => {
          this.conversationConfigExists = !!config;
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
